<template>
  <q-layout view="lHr lpR lFr">
    <q-header class="bg-primary text-white" v-if="showHeader">
      <tool-bar />
      <customers-bar />
      <router-view name="searchbar" />
      <router-view name="categoryLevel1" />
      <router-view name="categoryLevel2" />
      <router-view name="categoryLevel3" />
      <router-view name="header" />
      <router-view name="subheader" />
      <!-- <search-bar/> -->
    </q-header>

    <!-- <q-drawer
            myProp="prop"
            show-iFf-above
            v-model="leftDrawerOpen"
            side="left"
        >
        </q-drawer> -->

    <q-page-container>
      <router-view v-if="showSearch && isHomePage" name="search" />
      <router-view v-else />
    </q-page-container>

    <q-footer v-if="isShow" class="bg-grey-8 shadow-3 text-white">
      <router-view name="footer" />
    </q-footer>
  </q-layout>
</template>

<style scoped>

.customer-list {
  border: 1px solid red;
  height: 100px;
}

</style>

<script>
import Auth from "@aws-amplify/auth";
import MenuBar from "../components/MenuBar.vue";
import CustomerList from "../components/CustomerList.vue";
import ToolBar from "../components/ToolBar.vue";
import CustomersBar from "../components/CustomersBar.vue";
import SearchBar from "../components/SearchBar.vue";
import { mapState } from "vuex";
import useLoadCatalogData from "@/mixins/useLoadCatalogData";
import useLoadSaleData from "@/mixins/useLoadSaleData";

export default {
  components: {
    MenuBar,
    CustomerList,
    ToolBar,
    CustomersBar,
    SearchBar,
  },
  name: "Portal",
  mixins: [useLoadCatalogData, useLoadSaleData],
  data() {
    return {
      leftDrawerOpen: false,
    };
  },
  computed: {
    ...mapState({
      showSearch: (state) => {
        const keyword = state.search.keyword;
        if (keyword == null) {
          return false;
        }
        if (keyword == "") {
          return false;
        }
        return true;
      },
    }),
    isHomePage() {
      return this.$route.name === "Home";
    },
    isShow() {
      return true;
      // switch (this.$route.name) {
      //   case "Cart":
      //     return false;
      //   case "Checkout":
      //     return false;
      //   default:
      //     return true;
      // }
    },
    branchCode() {
      return parseInt(this.$store.state["branch"]["branch"].code);
    },
    showHeader() {
      return this.$route.name !== "SaleChat";
    },
  },
  mounted() {
    this.loadCatalogData(this.branchCode);
    this.loadSaleData();

    // test
    this.$services.authentication.getApikey();
  },
  methods: {
    toggleLeftDrawer() {
      this.leftDrawerOpen = !this.leftDrawerOpen;
    },
    async onSignOut() {
      console.log("onSignOut");
      await Auth.signOut();
      this.$router.replace("/auth", (err) => {
        console.log(err, "ignored");
      });
    },
  },
};
</script>
